import { render } from "./ProductionAccountTableCt.vue?vue&type=template&id=72bcdaec"
import script from "./ProductionAccountTableCt.vue?vue&type=script&lang=js"
export * from "./ProductionAccountTableCt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__